import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Checkbox from '../../../Checkbox';
import InfoToolTip from '../../../InfoToolTip';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const BooleanFilter = ({
  handleClick, selected, label, help,
}) => (
  <div className="mr-3">
    <Wrapper onClick={handleClick}>
      <Checkbox
        checked={selected}
        className="mr-1"
      />
      <span>{label}</span>
    </Wrapper>
    {
      help && (
        <InfoToolTip text={help} />
      )
    }
  </div>
);

BooleanFilter.propTypes = {
  handleClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  help: PropTypes.string,
};

BooleanFilter.defaultProps = {
  help: null,
};

export default BooleanFilter;
